/**
 * Per-SKU restock request → Netyear (再入荷通知サポーター) modal proxy.
 *
 * Clicking a [data-restock-trigger] button opens the existing Netyear
 * restock modal (via the global openRestockSubmitModal() function) and
 * pre-selects the row's variant inside the modal's <select> element.
 */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-restock-trigger]');
  if (!trigger) return;

  event.preventDefault();

  const variantId = trigger.dataset.variantId;

  if (typeof openRestockSubmitModal !== 'function') {
    console.warn('[restock-proxy] openRestockSubmitModal() not found — Netyear app may not be loaded');
    return;
  }

  openRestockSubmitModal();

  // Close the mobile SKU list modal (.sku-list-modal) if it's open, so
  // only the restock modal is visible. Triggering a [data-sku-list-close]
  // click invokes the SkuListHost's proper close logic (returns the
  // sku-list DOM back to its desktop slot).
  const openSkuModal = document.querySelector('.sku-list-modal.is-open');
  if (openSkuModal) {
    const closeBtn = openSkuModal.querySelector('[data-sku-list-close]');
    closeBtn?.click();
  }

  // If a specific variant is requested (per-SKU click), preselect it in
  // the modal's <select>. If no variant is given (mobile-wide trigger
  // for fully sold-out products), leave the select at its default.
  if (variantId) {
    requestAnimationFrame(() => {
      const variantSelect = document.querySelector('select#restock-product-variantId, select[name="variant"].variant-select');
      if (!variantSelect) return;

      variantSelect.value = variantId;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
});
